import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Header() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
    closeNavbar(); // close menu after logout
  };

  // Function to close bootstrap navbar on mobile
  const closeNavbar = () => {
  const navbar = document.getElementById("navbarNavDropdown");
  if (!navbar) return;

  if (window.bootstrap && window.bootstrap.Collapse) {
    const collapse = window.bootstrap.Collapse.getInstance(navbar) 
      || new window.bootstrap.Collapse(navbar, { toggle: false });
    collapse.hide();
  } else {
    // Fallback: just remove "show" manually
    navbar.classList.remove("show");
  }
};


  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-3 px-lg-4 shadow sticky-top" style={{ zIndex: 1050 }}>
      <NavLink className="navbar-brand d-flex align-items-center" to="/" onClick={closeNavbar}>
        <img
          src="/logo.png"
          alt="CDP BirlaPaint"
          height="40"
          className="d-inline-block align-top me-2"
        />
      </NavLink>

      

      {isAuthenticated && (
        <>
        <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  'nav-link' + (isActive ? ' active fw-bold' : '')
                }
                onClick={closeNavbar}
              >
                <span className="fs-6 fw-bold">Customer Segmentation Builder</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/activation"
                className={({ isActive }) =>
                  'nav-link' + (isActive ? ' active fw-bold' : '')
                }
                onClick={closeNavbar}
              >
                <span className="fs-6 fw-bold">Segments & Activation</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/glossary"
                className={({ isActive }) =>
                  'nav-link' + (isActive ? ' active fw-bold' : '')
                }
                onClick={closeNavbar}
              >
                <span className="fs-6 fw-bold">Glossary</span>
              </NavLink>
            </li>
          </ul>

          <div className="d-flex align-items-center mt-2 mt-lg-0">
            <button
              className="btn btn-outline-light btn-sm d-flex align-items-center"
              onClick={handleLogout}
              title="Logout"
            >
              <i className="fas fa-sign-out-alt me-1"></i>
              <span className="d-none d-sm-inline">Logout</span>
            </button>
          </div>
        </div>
        </>
      )}
    </nav>
  );
}

export default Header;
